'use client'

import Link from 'next/link'
import React from 'react'
import { usePathname } from 'next/navigation'

const PATHS_WITHOUT_CTA = [
  new RegExp(/\/request-.*/), // MC request page
  new RegExp(/^\/prescriptions-online\/categories\/[^/]+\/.+/), // prescription questionnaire after medicine selection
  new RegExp(/\/specialist-referral-online\/.*/), // referral requests
  new RegExp(/\/mens-health\/ed\/quiz.*/),
]

export default function HeaderCta() {
  const pathname = usePathname()
  const show = !PATHS_WITHOUT_CTA.some((regex) => regex.test(pathname))

  if (!show) return null

  return (
    <Link
      className="focus-visible:outline-offset-3 flex h-[38px] shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-[#0b0b0f] px-[18px] text-center text-[14px] font-semibold leading-[18px] text-white transition-colors duration-[360ms] ease-[cubic-bezier(0.22,0.55,0.28,1)] hover:bg-[#242429] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#2563eb] lg:h-[42px] lg:px-6 lg:text-[15px]"
      href="/start"
    >
      Request care
    </Link>
  )
}
